import React, { useEffect, useState } from 'react';
import { Link } from '@material-ui/core';
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import AppTagChipArrayBottomCard from '../Applications/AppTagChipArrayBottomCard';
import Grid from "@material-ui/core/Grid";
import CardManager from '../CardManager';
import ProdInsideCard from './ProdInsideCard';
import AllAppsTile from '../Applications/AllAppsTile'
import AllAppsTable from "../Applications/AllAppsTable";
import ProdTagChipArrayTop from './ProdTagChipArrayTop';
// import ChangeViewArrayWithoutRouter from '../ChangeViewArrayWithoutRouter';
import ChangeViewArray from '../ChangeViewArray';
import SkeletonInsideCard from '../Skeleton/SkeletonInsideCard';
import SkeletonBlock from '../Skeleton/SkeletonBlock';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateBeforeIcon from '../../icons/ArrowLeftIcon';
import Helmet from "react-helmet";
import translate from '../../other/translate.json'
import icons_group from '../../other/icons_group.json';
import config from '../../other/config';
let moment = require('moment');
require("moment/min/locales.min");


const { serverAPI } = config;

export default function ProdCard(props) {
	let { prodBasketChips, basketChips, setAppBasket, bankinfo } = props
	let [view, _view] = useState(localStorage.getItem('view') || 'table')
	const language = localStorage.getItem('language') || 'Ru'
	language === 'Ru' ? moment.locale(`ru`) : moment.locale(`eng`)
	let { code } = useParams();
	const classes = useStyles();
	const [app, setApp] = useState({})
	const [appNeed, setNeedApp] = useState()
	const [appRecom, setRecomApp] = useState()
	const [loading, setloading] = React.useState(true);
	const [kloStatuses, _kloStatuses] = useState({});
	const [loadingKloStatuses, _loadingKloStatuses] = useState(false);

	const setView = (index) => {
		_view(index)
		localStorage.setItem('view', index)
	}

	// const getParamURLQuery = (srt, param) => {
	// 	let arr = srt.split('&')
	// 	let res1 = arr.filter(el => el.includes(param))
	// 	let Val = res1[0].split('=')[1];
	// 	if (res1 && res1[0] && Val) {
	// 		// if (param === 'bank=')   { _bank(Val) }
	// 		if (param === 'lang=') {
	// 			props.setIsRu(Val === 'true')
	// 		}
	// 	}
	// }
	// useEffect(() => {
	// 	if (history.location.search.includes('lang=')) {
	// 		getParamURLQuery(history.location.search, 'lang=')
	// 	}
	// }, []);

	useEffect(() => {
		if (app.AppsIDsNeededCount && app.AppsIDsNeededCount > 0) {
			let didCancel = false;
			async function fetchData() {

				if (!didCancel) {
					const AppsIDsNeeded = await axios.get(`${serverAPI}/appsv/${app.AppsIDsNeeded}/${language}?inCu=${props.userCollection.inCu}`)
					if (AppsIDsNeeded && AppsIDsNeeded.data) {
						setNeedApp(AppsIDsNeeded.data)
					}
					const AppsIDsRecommended_ = await axios.get(`${serverAPI}/appsv/${app.AppsIDsRecommended}/${language}?inCu=${props.userCollection.inCu}`)

					if (AppsIDsRecommended_ && AppsIDsRecommended_.data) {
						setRecomApp(AppsIDsRecommended_.data)
					}
				}
			}

			fetchData();

			return () => {
				didCancel = true;
			};
		} else {
			let didCancel = false;
			async function fetchData() {

				if (!didCancel) {
					const AppsIDsRecommended_ = await axios.get(`${serverAPI}/appsv/${app.AppsIDsRecommended}/${language}?inCu=${props.userCollection.inCu}`)

					if (AppsIDsRecommended_ && AppsIDsRecommended_.data) {
						setRecomApp(AppsIDsRecommended_.data)
					}
				}
			}

			fetchData();

			return () => {
				didCancel = true;
			};
		}
	}, [app]);

	useEffect(() => {
		if (props.kloUser && props.kloUser.user && props.kloUser.user.IS_BANK && Array.isArray(appNeed) && Array.isArray(appRecom)) {
			let didCancel = false;
			async function fetchData() {

				if (!didCancel) {


					try {
						_loadingKloStatuses(true);
						const statuses = await props.getKloStatuses(appNeed.concat(appRecom).map(el => el.codeasvul).join(','))
						//console.log(AppsIDsNeeded.data.concat(AppsIDsRecommended_.data).length, statuses )
						_kloStatuses(statuses);
						_loadingKloStatuses(false);
					} catch (e) {
						_loadingKloStatuses(false);
					}

				}


				/**/
			}

			fetchData();

			return () => {
				didCancel = true;
			};
		}
	}, [appNeed, appRecom, props.kloUser]);

	// useEffect(() => {
	// 	if (app.AppsIDsNeededCount && app.AppsIDsNeededCount > 0) {
	// 		let didCancel = false;
	// 		async function fetchData() {
	// 			const AppsIDsRecommended_ = await axios.get(`${serverAPI}/appsv/${app.AppsIDsRecommended}/${language}`)
	// 			if (!didCancel) {
	// 				if (AppsIDsRecommended_ && AppsIDsRecommended_.data) {
	// 					setRecomApp(AppsIDsRecommended_.data)
	// 				}
	// 			}
	// 		}

	// 		fetchData();

	// 		return () => {
	// 			didCancel = true;
	// 		};
	// 	}
	// }, [app]);

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			setloading(true)
			// const dataAllSection = await axios.get(`${serverAPI}/products_v2/${code}`)
			const cardinfo = await axios.get(`${serverAPI}/prodid/${code}/${language}?inCu=${props.userCollection.inCu}`)
			if (!didCancel) {
				if (cardinfo && cardinfo.data && cardinfo.data[0]) {
					let obj = {}
					for (const [key, value] of Object.entries(cardinfo.data[0])) {
						// if (key === 'Setting') { } else { // TODO с этим полем у нас проблема
						obj[`${key}`] = value
						// }
					}
					setApp(obj)
					setloading(false)
				} else {
					setApp([])
					setloading(false)
					props.setErr(true)
				}
			}
		}
		fetchData();
		return () => {
			didCancel = true;
		}
	}, [code]);
	/***/

	function handleClickBreadcrumb(event) {
		event.preventDefault();
		console.info('You clicked a breadcrumb.');
	}

	useEffect(() => {
		if (window.innerWidth < 1366) {
			setView('tile')
		}
	}, [window.innerWidth]);

	return (
		// <ThemeProvider>
		<Grid className={classes.root}>
			<Grid item container
				direction="row"
				justify="flex-start"
				alignItems="center"
				style={{ marginBottom: 0 }}
			>
				<Helmet
					title={app[`Title`] ? `${app[`Title`]} | ЦФТ-Банк` : ''}
				/>
			</Grid>

			<Grid item container style={{ margin: '36px 0', alignItems: 'center' }}>
				{
					loading === true
						?
						<SkeletonBlock height={24} width={25} />
						:
						<div>
							<NavigateBeforeIcon mb={'-7px'} fontSize="normal" fill="#BCBBD0" />
							<a href={`/products/${app.URL}/overview`} className={classes.Breadcrumb}>{app["title_catalog"]}</a> | <a href={`/products/cftbank/prodlist?area=${app['P_DirectionsID']}`} className={classes.Breadcrumb}>{app[`DirectionTitle`]}</a> | <a href={`/products/cftbank/prodlist?group=${app["Icon_GroupID"]}`} className={classes.Breadcrumb}>{app[`GroupTitle`]}</a> | <a href={`/products/cftbank/prodlist?subgroup=${app["SubGroupTitle"]}`} className={classes.Breadcrumb}>{app[`SubGroupTitle`]}</a> | <span style={{ fontSize: '16px' }}>{app[`Title`]}</span>
						</div>


					// <Breadcrumbs separator="|" aria-label="breadcrumb" className={classes.BC}>
					// 	<Grid item container style={{ maxHeight: 24, fontSize: '16px', lineHeight: '24px', color: '#8987A2', width: 'max-content' }}>
					// 		<Grid item>
					// 			<NavigateBeforeIcon fontSize="normal" fill="#BCBBD0" />
					// 		</Grid>

					// 		<Grid item>
					// 			<Link color="inherit" className={classes.Breadcrumb} href={`/products/${props.info.URL}/overview`} onClick={() => handleClickBreadcrumb} style={{ lineHeight: '24px' }}>
					// 				{app["title_catalog"]}
					// 			</Link>
					// 		</Grid>
					// 	</Grid>

					// 	<Link color="inherit" className={classes.Breadcrumb} href={`/products/cftbank/prodlist?area=${app['P_DirectionsID']}`} onClick={() => handleClickBreadcrumb}>
					// 		{app[`DirectionTitle`]}
					// 	</Link>

					// 	<Link color="inherit" className={classes.Breadcrumb} href={`/products/cftbank/prodlist?group=${app["Icon_GroupID"]}`} onClick={() => handleClickBreadcrumb}>
					// 		{app[`GroupTitle`]}
					// 	</Link>

					// 	<Link color="inherit" className={classes.Breadcrumb} href={`/products/cftbank/prodlist?subgroup=${app["SubGroupTitle"]}`} onClick={() => handleClickBreadcrumb}>
					// 		{app[`SubGroupTitle`]}
					// 	</Link>

					// 	<Typography color="#8987A2">{app[`Title`]}</Typography>
					// </Breadcrumbs>
				}
			</Grid>

			<Card className={classes.rootWide}>
				<Grid item className={classes.TopChipArrayCntr}>
					<ProdTagChipArrayTop position='topCard' data={app} header={app[`DirectionTitle`]} />
				</Grid>

				<Grid container className={classes.MainInfoCntr} direction="row" justify="space-between" alignItems="flex-start">
					<Grid item container justify="space-between" className={classes.AppInfoContainer} style={{ margin: 'auto' }}>
						<Grid container className={classes.BaseInfoContainer}>
							<Grid
								container
								direction="row"
								justify="flex-start"
								alignItems="flex-start"
							>
								<Grid item className={classes.AvatarContainer}>
									<Avatar
										aria-label="recipe"
										className={classes.avatar}
										style={{ backgroundColor: app.Color && app.Color.length > 5 ? `#${app.Color}` : '#E45670', padding: 12 }}
										src={icons_group[`${app.Icon_GroupID}`]}

									/>
								</Grid>

								<Grid item className={classes.ProdNameContainer}>
									<Typography className={classes.ProdName}>
										{app[`Title`]}
									</Typography>
								</Grid>
							</Grid>

							<Grid
								container
								direction="column"
								justify="flex-start"
								alignItems="flex-start"
								style={{ marginTop: 42 }}
							>
								<Grid item style={{ width: '100%' }}>
									<Typography className={classes.Caption2}>
										{translate.Words[`Group${language}`]}
									</Typography>
									{loading === true
										?
										<SkeletonBlock height={24} />
										:
										// <Typography className={classes.Body1}>
										// 	{app[`GroupTitle`]}
										// </Typography>

										<Link
											href={`/products/cftbank/prodlist?group=${app[`Icon_GroupID`]}`}
											className={classes.LinkType12}
										>
											{app[`GroupTitle`]}
										</Link>
									}
								</Grid>

								<Grid item container style={{ marginTop: 25 }}>
									<Grid item container alignItems="center">
										<Typography component="p" className={classes.Caption2}>
											{translate.Words[`SubGroup${language}`]}
										</Typography>
									</Grid>

									{loading === true
										?
										<SkeletonBlock height={24} />
										:
										// <Typography className={classes.Body1}>
										// 	{app[`SubGroupTitle`]}
										// </Typography>

										<Link
											href={`/products/cftbank/prodlist?group=&subgroup=${app[`SubGroupTitle`]}`}
											className={classes.LinkType12}
										>
											{app[`SubGroupTitle`]}
										</Link>
									}
								</Grid>

								<Grid item container style={{ paddingTop: 38 }}>
									<Typography className={classes.Body1} style={{ color: '#8987A2' }}>
										{app[`BriefDescription`]}
									</Typography>
								</Grid>
							</Grid>
						</Grid>

						<Grid container className={classes.AppInsideCardContainer}>
							{loading === true
								?
								<SkeletonInsideCard />
								:
								<ProdInsideCard
									isAuth={props.isAuth}
									usname={props.usname}
									prodBasketChips={prodBasketChips}
									prod={app}
									SumAppsNeeded={app.SumAppsNeeded < 999998 ? app.SumAppsNeeded : 0}
									SumAppsRecommended={app.SumAppsRecommended < 999998 ? app.SumAppsRecommended : 0}
									rsbu={app.CommentIFRS === '1' ? `${translate.Words[`InRespectOfIFRSReporting${language}`]}` : ''}
									countNeeded={app.AppsIDsNeededCount}
									countRecom={app.AppsCodeRecommendedCount}
									IsResearchMarket={app.IsResearchMarket} DateStartStock={app.DateStartStock} DateEndSaleStock={app.DateStartStock}
									price1={app.PaymentOne} price2={app.PaymentMonthly} price3={app.PaymentOneStock} price4={app.PaymentMonthlyStock}
									price1Com={app[`PaymentComment`]} price2Com={app[`PaymentCommentOne`]} price3Com={app[`PaymentCommentMonthly`]}
									userCollection={props.userCollection}
									saveCollection={props.saveCollection}
									product={app}
								/>
							}
						</Grid>
					</Grid>
				</Grid>

				<Grid className={classes.ExtInfoContainer}>
					{
						app[`Tags`] && app[`Tags`].length > 0
							?
							<Grid item container justify="flex-start" alignItems="center" className={classes.MiddleChipArrayCntr}>
								<AppTagChipArrayBottomCard position='middle' Tags={app[`Tags`]} icon={true} />
							</Grid>
							:
							''
					}

					<CardContent className={classes.content}>
						<Grid container direction="column" justify="flex-start" alignItems="flex-start">
							{/* {

								app && app[`HTMLFunction`] && app[`HTMLFunction`].length > 0
									?
									<Grid item xs={12} className={classes.block}>
										<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader}>
											{translate.Words[`KeyFunctions${language}`]}
										</Typography>

										<Typography variant="body2" color="textSecondary" component="ul" className={classes.contentBodyLi} style={{ marginTop: 40, paddingInlineStart: 17 }}>
											{app && app[`HTMLFunction`] && <div dangerouslySetInnerHTML={{ __html: app && app[`HTMLFunction`] ? app[`HTMLFunction`] : '' }}></div>}
										</Typography>
									</Grid>
									:
									''
							} */}
							{app.Setting && eval(app.Setting) && eval(app.Setting).length > 0 ?
								<Grid item container direction="column" xs={12} className={[classes.block, classes.ExtraContainer]}>
									<Grid item>
										<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader}>
											{/* Настройки продукта */}
											{translate.Words[`ProdSettings${language}`]}
										</Typography>
									</Grid>

									<Grid item style={{ marginTop: 24 }}>
										<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
											{translate.Words[`ProductInfo${language}`]}

										</Typography>
									</Grid>

									<Grid item container direction="column" style={{ paddingTop: 25 }}>
										<Grid item container direction="row" style={{ borderBottom: '2px solid #000' }}>
											<Grid item xs={6} style={{ paddingBottom: 16 }}>
												<Typography className={classes.Title4}>{translate.Words[`ProductParameters${language}`]}  </Typography>
											</Grid>

											<Grid item xs={6} style={{ paddingLeft: 24, paddingBottom: 16, borderLeft: '1px solid #BCBBD0' }}>
												<Typography className={classes.Title4}>{translate.Words[`ProductSetup${language}`]} </Typography>
											</Grid>
										</Grid>

										{app.Setting && eval(app.Setting) && eval(app.Setting).length > 0 ?
											eval(app.Setting).map(el => {
												let logicHide = language === 'Ru' ? el.Tuning_Ru : el.Tuning_Eng
												if (logicHide !== undefined)
													return (
														<Grid item container direction="row" style={{ borderBottom: '1px solid #BCBBD0' }}>
															<Grid item xs={6} style={{ padding: '24px 0' }}>
																<Typography className={classes.Body1}> <div dangerouslySetInnerHTML={{ __html: language === 'Ru' ? el.Tuning_Ru : el.Tuning_Eng }}></div> </Typography>
															</Grid>

															<Grid item xs={6} style={{ padding: '24px 0 24px 24px', borderLeft: '1px solid #BCBBD0' }}>
																<Typography className={classes.Body1} style={{ color: '#8987A2' }}><div dangerouslySetInnerHTML={{ __html: language === 'Ru' ? el.Example_Ru : el.Example_Eng }}></div></Typography>
															</Grid>
														</Grid>
													)
											})
											:
											''
										}
									</Grid>
								</Grid>
								:
								''
							}
							{app[`HTMLContent`] && app[`HTMLContent`].length > 0 ?
								// classes.block, classes.ExtraContainer - что тут лишнее codeerr
								<Grid item container direction="column" xs={12} className={[classes.block, classes.ExtraContainer]}>
									<Grid item>
										<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader}>
											Решаемые бизнес-задачи:
										</Typography>
									</Grid>

									<Grid item style={{ marginTop: 40 }}>
										<Typography component="ul" className={classes.contentBody} dangerouslySetInnerHTML={{ __html: app[`HTMLContent`] }}>
										</Typography>
									</Grid>
								</Grid>
								: ''}
						</Grid>
					</CardContent>
				</Grid>
			</Card >

			<Grid item container className={classes.block} style={{ marginTop: 33 }}>
				{app.AppsIDsNeededCount + app.AppsCodeRecommendedCount > 0
					?
					<Grid item container direction="row" justify="space-between" alignItems="center">
						<Grid item>
							<Typography className={classes.Title2}>{translate.Words[`Applications_${language}`]}</Typography>
						</Grid>

						<Grid item className={classes.cntrChangeView}>
							<ChangeViewArray
								selected={view === 'tile' ? 1 : 0}
								handleView={setView}
							/>
						</Grid>
					</Grid>
					:
					null
				}

				{/* {selectedIndex === 1 ? <> */}
				{appNeed && appNeed.length > 0 ?
					<Grid item container style={{ marginTop: 50, padding: 0 }}>
						<Grid item container>
							<Typography className={classes.Title4}> {translate.Words[`RequiredApplications_${language}`]} </Typography>
						</Grid>

						<Grid item container style={{ marginTop: 14 }}>
							{appNeed ?
								view === 'tile' ?
									<AllAppsTable
										isProd={true}
										basket={true}
										type={'applications'}
										basketChips={basketChips}
										setAppBasket={setAppBasket}
										readLink={false}
										cardArr={appNeed}
										bank={props.bank}
										mt={'16px'}
										kloStatuses={kloStatuses}
										kloUser={props.kloUser}
										loadingKloStatuses={loadingKloStatuses}
										userCollection={props.userCollection}
										saveCollection={props.saveCollection}
									/>
									:
									<AllAppsTile
										isProd={true}
										type={'applications'}
										readLink={false}
										basket={true}
										basketChips={basketChips}
										setAppBasket={setAppBasket}
										cardArr={appNeed}
										bank={props.bank}
										kloStatuses={kloStatuses}
										kloUser={props.kloUser}
										loadingKloStatuses={loadingKloStatuses}
										userCollection={props.userCollection}
										saveCollection={props.saveCollection}
									/>
								:
								''
							}
						</Grid>
					</Grid>
					:
					''
				}

				{appRecom && appRecom.length > 0 ?
					<Grid item container style={{ marginTop: 26, padding: 0 }}>
						<Grid item container>
							<Typography className={classes.Title4}>{translate.Words[`RecommendedApplications${language}`]}</Typography>
						</Grid>

						<Grid item container style={{ marginTop: 14 }}>
							{appRecom ?
								view === 'tile' ?
									<AllAppsTable
										isProd={true}
										basket={true}
										type={'applications'}
										basketChips={basketChips}
										setAppBasket={setAppBasket}
										readLink={false}
										cardArr={appRecom}
										bank={props.bank}
										mt={'16px'}
										kloStatuses={kloStatuses}
										kloUser={props.kloUser}
										loadingKloStatuses={loadingKloStatuses}
										userCollection={props.userCollection}
										saveCollection={props.saveCollection}
									/>
									:
									<AllAppsTile
										isProd={true}
										type={'applications'}
										basket={true}
										readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink}
										basketChips={basketChips}
										setAppBasket={setAppBasket}
										cardArr={appRecom}
										bank={props.bank}
										kloStatuses={kloStatuses}
										kloUser={props.kloUser}
										loadingKloStatuses={loadingKloStatuses}
										userCollection={props.userCollection}
										saveCollection={props.saveCollection}
									/>
								:
								''
							}
						</Grid>
					</Grid>
					:
					''
				}
			</Grid>

			<Grid item xs={12} className={classes.block} style={{ marginTop: 53 }}>
				<Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader} style={{ marginBottom: 41, textAlign: 'center' }}>
					{app[`Managers`] && app[`Managers`].length > 0 ? translate.Words[`FAQ${language}`] + ':' : ''}
				</Typography>

				<Grid
					item
					container
					direction="row"
					justify="center"
					alignItems="flex-start"
					spacing={3}
					style={{ marginTop: 40 }}
				// style={{ maxWidth: 872, margin: '40px auto' }}
				>
					{app[`Managers`] && /;#;/.test(app[`Managers`]) ? app[`Managers`].split(';#;').map((item, index) => {
						return (
							<Grid item>
								<CardManager data={item} />
							</Grid>
						)
					}
					) : <Grid item>
						<CardManager data={app[`Managers`]} />
					</Grid>
					}
				</Grid>
			</Grid>
		</Grid >
		// </ThemeProvider >
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		marginTop: "-58px" // Спорное решение, но влом переписывать всю цепочку TODO: ПЕРЕПИСАТЬ ЧТОБ ЭТО НЕ ТРЕБОВАЛОСЬ
	},

	rootWide: {
		// maxWidth: 345,
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		borderRadius: theme.spacing(2),
		padding: 30,
		// padding: theme.spacing(3),
		minWidth: '100%',
		// '&:hover': {
		// 	boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
		// }
		[theme.breakpoints.down(696)]: {
			padding: '30px 24px',
		}
	},

	avatar: {
		// backgroundColor: props.iconColor,
		height: 55,
		width: 55,
		borderRadius: 15
	},

	icon: {
		marginLeft: 8,
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	content: {
		// height: 289,
		// overflow: 'hidden',
		padding: 0,
		marginTop: -17
	},

	// contentBody: {
	// 	fontSize: '14px',
	// 	fontWeight: '500',
	// 	lineHeight: '18px',
	// 	color: '#000'
	// },

	contentHeader: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '28px',
		lineHeight: '40px',
		// textAlign: 'center',
		color: '#000000',
		textAlign: 'left'
	},

	contentBody: {
		// marginTop: theme.spacing(1),
		fontSize: '16px',
		fontWeight: '400',
		lineHeight: '24px',
		color: '#8987A2'
	},

	contentBodyLi: {
		// marginTop: theme.spacing(1),
		fontSize: '16px',
		fontWeight: '400',
		lineHeight: '24px',
		color: '#8987A2',
		'&>li': {
			marginBottom: 24,
			paddingLeft: 13,
		}
	},

	header: {
		padding: 0,
	},

	Title2: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '28px',
		lineHeight: '40px',
		color: '#24262A',
	},

	Title3: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '24px',
		lineHeight: '32px',
		color: '#24262A',
	},

	Caption2: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
		color: '#8987A2',
		marginBottom: 3
	},

	Body1: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '16px',
		lineHeight: '24px',
		color: '#24262A',
	},

	pricePrimary: {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '18px',
		color: '#000'
	},

	priceSecondary: {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '18px',
		color: '#8987A2'
	},

	rectangle593: {
		width: 120,
		height: 120,
		borderRadius: 80,
		backgroundColor: '#EB505E'
	},

	Rectangle614: {
		backgroundColor: '#F6F6FB',
		borderRadius: 16
	},

	ReleaseDataCaption: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
		color: '#8987A2'
	},

	ReleaseDataBody: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '16px',
		lineHeight: '24px',
		color: '#000000',
		marginTop: 4
	},

	block: {
		marginTop: 80
	},

	DevelopmentDynamicsBlock: {
		margin: '20px 0'
	},

	DevelopmentDynamicsBlockCaption: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A'
	},

	DevelopmentDynamicsBlockBody: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		marginTop: 4
	},

	PrevCard: {
		transform: 'rotate(180deg)',
		display: 'flex'
	},

	NextCard: {
		display: 'flex'
	},

	AvatarContainer: {
		width: 79,

		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	ProdNameContainer: {
		width: 'calc(100% - 79px)',

		[theme.breakpoints.down(1032)]: {
			width: '100%'
		}
	},

	AppInfoContainer: {
		[theme.breakpoints.up(1702)]: {
			maxWidth: 1096
		},

		[theme.breakpoints.down(1702)]: {
			// maxWidth: 766
			maxWidth: 758
		},

		[theme.breakpoints.down(1032)]: {
			maxWidth: 568
		},
	},

	BaseInfoContainer: {
		[theme.breakpoints.up(1702)]: {
			maxWidth: 648
		},
	},

	AppInsideCardContainer: {
		[theme.breakpoints.up(1702)]: {
			maxWidth: 424
		},

		[theme.breakpoints.down(1702)]: {
			marginTop: 40
		},

		[theme.breakpoints.down(696)]: {
			maxWidth: 264,
			marginTop: 40
		}
	},

	ExtInfoContainer: {
		[theme.breakpoints.up(1702)]: {
			padding: '0 192px'
		},

		[theme.breakpoints.down(1702)]: {
			padding: '0 78px'
		},

		[theme.breakpoints.down(1032)]: {
			padding: '0 5px'
		},
	},

	ExtraContainer: {
		marginTop: 56,

		// [theme.breakpoints.down(1032)]: {
		// 	display: 'none'
		// }
	},

	LicensedContainer: {
		marginTop: 77,

		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	ReleaseDataContainer: {
		marginTop: 79,

		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	DevDynamicsContainer: {
		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	Title4: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '18px',
		lineHeight: '28px',
		color: '#24262A',
	},

	TopChipArrayCntr: {
		float: 'right',
		marginRight: '-12px'
	},

	MainInfoCntr: {
		paddingTop: 46,

		[theme.breakpoints.down(696)]: {
			paddingTop: 18,
		}
	},

	ProdName: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '24px',
		lineHeight: '32px',

		[theme.breakpoints.down(696)]: {
			fontFamily: 'Cera CY',
			fontStyle: 'normal',
			fontWeight: '500',
			fontSize: '22px',
			lineHeight: '30px',
		}
	},

	MiddleChipArrayCntr: {
		height: 104,
		borderBottom: '1px solid #EEEEF5',

		[theme.breakpoints.down(1032)]: {
			display: 'none'
		}
	},

	LinkType12: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#24262A',
		textDecoration: 'none',
		borderBottom: '1px dashed rgba(0, 0, 0, 0.4)',

		'&:hover': {
			color: '#2050FF',
			textDecoration: 'none',
			borderBottom: '1px dashed #2050FF',
		}
	},

	BC: {
		height: 96,

		'& ol': {
			flexWrap: 'nowrap'
		}
	},

	Breadcrumb: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: 'none',

		'&:hover': {
			color: '#24262A',
			textDecoration: 'none',
			borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
		}
	},

	cntrChangeView: {
		marginRight: 0,

		[theme.breakpoints.down(1366)]: {
			display: 'none'
		}
	},
}));